<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <div class="d-flex">
        <div class="navbar-brand-box">
          <a routerLink="/" class="logo">
            <span class="logo-sm">
              <img
                src="assets/images/brands/tsolife-ico-250x250.svg"
                alt=""
                height="22" />
            </span>
            <span class="logo-lg">
              <img
                src="assets/images/brands/tsolife-logo-200x45.svg"
                alt=""
                height="40" />
            </span>
          </a>
        </div>
        <div class="dropdown d-inline-block" ngbDropdown>
          <button
            type="button"
            class="btn btn-sm px-3 font-size-16 d-lg-none header-item"
            id="page-header-dropdown"
            ngbDropdownToggle>
            <i class="fa fa-fw fa-bars"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-start" ngbDropdownMenu>
            <li class="nav-item dropdown" *ngFor="let item of menuItems">
              <a
                class="dropdown-item"
                *ngIf="!item.subItems && !item.externalUrl"
                id="topnav-components-main-internal"
                [routerLink]="item.link"
                role="button">
                <i class="bx {{ item.icon }} me-2"></i
                >{{ item.label | translate }}
                <div class="arrow-down" *ngIf="hasItems(item)"></div>
              </a>

              <a
                class="dropdown-item"
                *ngIf="!item.subItems && item.externalUrl"
                [href]="item.externalUrl"
                id="topnav-components-main-extrenal"
                target="_blank"
                role="button">
                <i class="bx {{ item.icon }} me-2"></i
                >{{ item.label | translate }}
                <div class="arrow-down" *ngIf="hasItems(item)"></div>
              </a>

              <ngb-accordion
                #accordion="ngbAccordion"
                *ngIf="item.subItems"
                id="topnav-components">
                <ngb-panel>
                  <ng-template ngbPanelTitle>
                    {{ item.label | translate }}
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div *ngIf="hasItems(item)">
                      <ng-template
                        ngFor
                        let-i="index"
                        let-subitem
                        [ngForOf]="item.subItems">
                        <a
                          *ngIf="
                            item.subItems.length < 11 && !hasItems(subitem)
                          "
                          class="col dropdown-item side-nav-link-ref"
                          [routerLink]="subitem.link"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{ exact: true }">
                          {{ subitem.label }}
                        </a>
                        <div *ngIf="item.subItems.length > 11">
                          <div *ngIf="i % 3 === 0" class="row">
                            <div class="col-lg-4">
                              <a
                                class="dropdown-item side-nav-link-ref"
                                routerLinkActive="active"
                                [routerLink]="subitem.link"
                                >{{ item.subItems[i].label | translate }}</a
                              >
                            </div>
                            <div class="col-lg-4">
                              <a
                                class="dropdown-item side-nav-link-ref"
                                routerLinkActive="active"
                                [routerLink]="item.subItems[i + 1].link">
                                {{ item.subItems[i + 1].label | translate }}
                              </a>
                            </div>
                            <div class="col-lg-4">
                              <a
                                class="dropdown-item side-nav-link-ref"
                                routerLinkActive="active"
                                [routerLink]="item.subItems[i + 2].link">
                                {{ item.subItems[i + 2].label | translate }}
                              </a>
                            </div>
                          </div>
                        </div>

                        <div class="dropdown" *ngIf="hasItems(subitem)">
                          <a
                            class="dropdown-item dropdown-toggle"
                            href="javascript: void(0);"
                            >{{ subitem.label | translate }}
                            <div class="arrow-down"></div>
                          </a>
                          <div class="dropdown-menu">
                            <ng-template
                              ngFor
                              let-subSubitem
                              [ngForOf]="subitem.subItems">
                              <a
                                class="dropdown-item side-nav-link-ref"
                                *ngIf="!hasItems(subSubitem)"
                                href="javascript: void(0);"
                                [routerLink]="subSubitem.link"
                                routerLinkActive="active"
                                >{{ subSubitem.label | translate }}</a
                              >
                              <div
                                class="dropdown"
                                *ngIf="hasItems(subSubitem)">
                                <a
                                  class="dropdown-item dropdown-toggle"
                                  href="javascript: void(0);"
                                  >{{ subSubitem.label | translate }}
                                  <div class="arrow-down"></div>
                                </a>
                                <div class="dropdown-menu">
                                  <ng-template
                                    ngFor
                                    let-subSubSubitem
                                    [ngForOf]="subSubitem.subItems">
                                    <a
                                      class="dropdown-item side-nav-link-ref"
                                      href="javascript: void(0);"
                                      [routerLink]="subSubSubitem.link"
                                      routerLinkActive="active"
                                      >{{ subSubSubitem.label | translate }}</a
                                    >
                                  </ng-template>
                                </div>
                              </div>
                            </ng-template>
                          </div>
                        </div>
                      </ng-template>
                    </div>
                  </ng-template>
                </ngb-panel>
              </ngb-accordion>
            </li>
          </div>
        </div>
      </div>
      <div
        class="d-flex topnav topnav-no-fixed mt-2 position-static bg-transparent shadow-none">
        <div class="container-fluid">
          <nav class="navbar navbar-light navbar-expand-lg topnav-menu active">
            <div
              class="collapse navbar-collapse active"
              id="topnav-menu-content">
              <ul class="navbar-nav">
                <ng-container *ngFor="let item of menuItems">
                  <li class="nav-item dropdown">
                    <a
                      class="nav-link dropdown-toggle arrow-none"
                      *ngIf="!item.subItems && !item.externalUrl"
                      id="topnav-components-main-internal"
                      [routerLink]="item.link"
                      role="button">
                      <i class="bx {{ item.icon }} me-2"></i>
                      {{ item.label | translate }}
                      <div class="arrow-down" *ngIf="hasItems(item)"></div>
                    </a>

                    <a
                      class="nav-link dropdown-toggle arrow-none"
                      *ngIf="!item.subItems && item.externalUrl"
                      [href]="item.externalUrl"
                      id="topnav-components-main-extrenal"
                      target="_blank"
                      role="button">
                      <i class="bx {{ item.icon }} me-2"></i
                      >{{ item.label | translate }}
                      <div class="arrow-down" *ngIf="hasItems(item)"></div>
                    </a>

                    <a
                      *ngIf="item.subItems"
                      class="nav-link dropdown-toggle arrow-none"
                      (click)="onMenuClick($event)"
                      href="javascript: void(0);"
                      id="topnav-components"
                      role="button">
                      <i class="bx {{ item.icon }} me-1"></i>
                      {{ item.label | translate }}
                      <div class="arrow-down"></div>
                    </a>

                    <div
                      class="dropdown-menu"
                      [ngClass]="{
                        'dropdown-mega-menu-xl px-2':
                          item.subItems && item.subItems.length > 11
                      }"
                      aria-labelledby="topnav-dashboard"
                      *ngIf="hasItems(item)">
                      <ng-template
                        ngFor
                        let-i="index"
                        let-subitem
                        [ngForOf]="item.subItems">
                        <a
                          *ngIf="
                            item.subItems &&
                            item.subItems.length < 11 &&
                            !hasItems(subitem)
                          "
                          class="col dropdown-item side-nav-link-ref"
                          [routerLink]="subitem.link"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{ exact: true }">
                          {{ subitem.label | translate }}
                        </a>
                        <div *ngIf="item.subItems && item.subItems.length > 11">
                          <div *ngIf="i % 3 === 0" class="row">
                            <div class="col-lg-4">
                              <a
                                class="dropdown-item side-nav-link-ref"
                                routerLinkActive="active"
                                [routerLink]="subitem.link">
                                {{ item.subItems[i].label | translate }}
                              </a>
                            </div>
                            <div class="col-lg-4">
                              <a
                                class="dropdown-item side-nav-link-ref"
                                routerLinkActive="active"
                                [routerLink]="item.subItems[i + 1].link">
                                {{ item.subItems[i + 1].label | translate }}
                              </a>
                            </div>
                            <div class="col-lg-4">
                              <a
                                class="dropdown-item side-nav-link-ref"
                                routerLinkActive="active"
                                [routerLink]="item.subItems[i + 2].link">
                                {{ item.subItems[i + 2].label | translate }}
                              </a>
                            </div>
                          </div>
                        </div>

                        <div class="dropdown" *ngIf="hasItems(subitem)">
                          <a
                            class="dropdown-item dropdown-toggle"
                            href="javascript: void(0);"
                            (click)="onMenuClick($event)"
                            >{{ subitem.label | translate }}
                            <div class="arrow-down"></div>
                          </a>
                          <div class="dropdown-menu">
                            <ng-template
                              ngFor
                              let-subSubitem
                              [ngForOf]="subitem.subItems">
                              <a
                                class="dropdown-item side-nav-link-ref"
                                *ngIf="!hasItems(subSubitem)"
                                href="javascript: void(0);"
                                [routerLink]="subSubitem.link"
                                routerLinkActive="active"
                                >{{ subSubitem.label | translate }}</a
                              >
                              <div
                                class="dropdown"
                                *ngIf="hasItems(subSubitem)">
                                <a
                                  class="dropdown-item dropdown-toggle"
                                  href="javascript: void(0);"
                                  (click)="onMenuClick($event)"
                                  >{{ subSubitem.label | translate }}
                                  <div class="arrow-down"></div>
                                </a>
                                <div class="dropdown-menu">
                                  <ng-template
                                    ngFor
                                    let-subSubSubitem
                                    [ngForOf]="subSubitem.subItems">
                                    <a
                                      class="dropdown-item side-nav-link-ref"
                                      href="javascript: void(0);"
                                      [routerLink]="subSubSubitem.link"
                                      routerLinkActive="active"
                                      >{{ subSubSubitem.label | translate }}</a
                                    >
                                  </ng-template>
                                </div>
                              </div>
                            </ng-template>
                          </div>
                        </div>
                      </ng-template>
                    </div>
                  </li>
                </ng-container>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center">
      <div class="d-inline-block" *ngIf="!isLoggedIn; else accountMenu">
        <button id="login-button" class="btn w-md" (click)="onOpenLoginModal()">
          Login
        </button>
      </div>

      <ng-template #accountMenu>
        <app-page-header-user-dropdown></app-page-header-user-dropdown>
      </ng-template>

      <a
        *ngIf="!isLoggedIn"
        class="btn schedule-demo-button text-white fw-medium cursor-pointer"
        href="https://calendly.com/tsolife-david-sawyer/60min"
        target="_blank">
        Schedule Demo
      </a>
    </div>
  </div>
</header>
